module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answers"
  }, _vm._l((_vm.answers), function(ref, index) {
    var text = ref.text;
    var value = ref.value;

    return _c('div', {
      key: index,
      staticClass: "answers__row"
    }, [_c('h2', {
      staticClass: "answers__result"
    }, [_vm._v(_vm._s(text) + " — "), _c('span', [_vm._v("ваша оценка: " + _vm._s(value))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2f0949","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/anketaresult/Result.vue
// module id = cc4ee88fb6a058f900d3
// module chunks = 5